module.exports = __webpack_public_path__ + "static/media/TSectionGeometry.8a86ce13.svg";